export default __webpack_public_path__ + "static/media/pills@3x.006e60da.png";